<template>
  <div class="artists">
    <Heading
      class="artists__title"
      font-color="#EE396C"
    >
      Artistas
    </Heading>
    <Heading
      class="artists__subtitle"
      font-size="36px"
      line-height="50px"
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
      labore
    </Heading>

    <ul
      :class="{ 'has-no-desktop-slider': hasNoDesktopSlider }"
      class="artists-carrousel"
    >
      <li
        v-for="(artist, i) in artists"
        :key="i"
        class="artists-carrousel__item"
        @click="gotoLeilao(artist.goToIndex)"
      >
        <v-img
          class="artists-carrousel__img"
          :src="artist.img"
        ></v-img>
        <span>{{ artist.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';

export default {
  name: 'ArtistsCarrousel',
  components: {
    Heading,
  },
  props: {
    artists: {
      type: Array,
      default: () => [],
      require: true,
    },
    hasNoDesktopSlider: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    gotoLeilao(n) {
      this.$router.push({
        name: this.$consts.ROUTES.LEILOES.NAME,
        params: {
          leilao: n,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.artists {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-bottom: 150px;
  padding-top: 60px;
  overflow: hidden;

  @media (max-width: $md) {
    padding-top: 20px;
    padding-bottom: 40px;
    margin-top: 40px !important;
  }

  &__title {
    margin-bottom: 30px;
    text-align: center;
    @media (max-width: $md) {
      font-size: 26px !important;
      line-height: 30px !important;
    }
  }

  &__subtitle {
    text-align: center;
    @media (max-width: $md) {
      font-size: 16px !important;
      line-height: 20px !important;
    }
  }

  &-carrousel {
    display: flex;
    align-items: center;
    list-style: none;
    margin-top: 85px;
    max-width: 100vw;
    padding-bottom: 20px;
    overflow-x: scroll;
    @media (max-width: $lg) {
      scroll-snap-type: x mandatory;
    }
    @media (max-width: $md) {
      margin-top: 30px;
    }

    @media (min-width: $md) {
      &.has-no-desktop-slider {
      flex-wrap: wrap;
      overflow: initial;

        li {
          width: 25%;
          margin: 65px auto;
        }
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      scroll-snap-align: start;
      cursor: pointer;

      > span {
        display: block;
        margin-top: 20px;
        text-align: center;
      }

      & + li {
        margin-left: 85px;
      }
    }

    &__img {
      max-width: 170px;
      max-height: 165px;
    }
  }
}
</style>
